import { ArrowDownRight, ArrowUpRight, IndianRupee, MessageSquareWarning, Minus, Star, Undo2 } from "lucide-react";

const inr = (v) => `₹${Math.round(v || 0).toLocaleString("en-IN")}`;

const Delta = ({ cur, prev, goodWhenUp, fmt, unit = "" }) => {
  if (cur == null || prev == null) return <span className="text-xs text-slate-400">No previous data</span>;
  const diff = cur - prev;
  const flat = Math.abs(diff) < 1e-9;
  const good = flat ? null : (diff > 0) === goodWhenUp;
  const Icon = flat ? Minus : diff > 0 ? ArrowUpRight : ArrowDownRight;
  const cls = good === null ? "bg-slate-100 text-slate-600" : good ? "bg-emerald-50 text-emerald-700" : "bg-red-50 text-red-600";
  return (
    <span className="flex flex-wrap items-center gap-2 text-xs">
      <span className={`inline-flex items-center gap-0.5 rounded-full px-2 py-0.5 font-semibold ${cls}`} data-testid="kpi-delta">
        <Icon className="h-3.5 w-3.5" />{flat ? "No change" : `${diff > 0 ? "+" : "−"}${fmt(Math.abs(diff))}${unit}`}
      </span>
      <span className="text-slate-400">was {fmt(prev)}{unit === " pts" ? "%" : ""}</span>
    </span>
  );
};

const Kpi = ({ label, value, icon: Icon, tone, testid, children, note }) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-5 fade-up" data-testid={testid}>
    <div className="flex items-center justify-between">
      <span className="text-sm font-medium text-slate-500">{label}</span>
      <span className={`rounded-xl p-2 ${tone}`}><Icon className="h-4 w-4" /></span>
    </div>
    <div className="mt-3 font-display text-3xl font-bold tracking-tight text-slate-900" data-testid={`${testid}-value`}>{value}</div>
    {note && <div className="mt-0.5 text-xs text-slate-400">{note}</div>}
    <div className="mt-3 min-h-[22px]">{children}</div>
  </div>
);

export const KpiCards = ({ k, compare }) => {
  const c = k.current;
  const p = k.previous;
  const num = (v) => Number(v).toFixed(2);
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4" data-testid="kpi-cards">
      <Kpi label="Average rating" value={c.avg_rating ? `${c.avg_rating} ★` : "—"} icon={Star} tone="bg-amber-50 text-amber-600" testid="kpi-avg-rating" note={`${c.ratings_count.toLocaleString("en-IN")} ratings`}>
        {compare && <Delta cur={c.avg_rating} prev={p.avg_rating} goodWhenUp fmt={num} />}
      </Kpi>
      <Kpi label="Negative feedback" value={`${c.negative_pct}%`} icon={MessageSquareWarning} tone="bg-red-50 text-red-600" testid="kpi-negative-pct" note={`${c.negative} of ${c.total.toLocaleString("en-IN")} feedback`}>
        {compare && <Delta cur={c.negative_pct} prev={p.total ? p.negative_pct : null} goodWhenUp={false} fmt={(v) => Number(v).toFixed(1)} unit=" pts" />}
      </Kpi>
      <Kpi label="Refund requested" value={inr(c.refund_requested)} icon={IndianRupee} tone="bg-slate-100 text-slate-700" testid="kpi-refund-requested" note={`${c.complaints} Zomato/Swiggy complaints`}>
        {compare && <Delta cur={c.refund_requested} prev={p.refund_requested} goodWhenUp={false} fmt={inr} />}
      </Kpi>
      <Kpi label="Refund given" value={inr(c.refund_given)} icon={Undo2} tone="bg-rose-50 text-rose-600" testid="kpi-refund-given" note={c.refund_requested ? `${Math.round((100 * c.refund_given) / c.refund_requested)}% of requested` : "No refund requests"}>
        {compare && <Delta cur={c.refund_given} prev={p.refund_given} goodWhenUp={false} fmt={inr} />}
      </Kpi>
    </div>
  );
};
